<section class="spremiste-zaglavlje">
  <ng-container *ngIf="parentArchiveName">
    <p>{{ parentArchiveName }}</p>
  </ng-container>
  <ng-container *ngIf="parentObjectName">
    <ul class="flex list-none p-0">
      <li class="p-3">
        <h3><span class="pi pi-building"></span>{{ parentObjectName }}</h3>
        <ng-container *ngIf="parentObjectAdress">
          <p><strong>Adresa:</strong> {{ parentObjectAdress }}</p>
        </ng-container>
        <ng-container *ngIf="parentObjectArea">
          <p><strong>Površina:</strong> {{ parentObjectArea }}</p>
        </ng-container>
      </li>

      <ng-container *ngIf="parentProstorijaName">
        <p-divider layout="vertical" ></p-divider>
        <li class="p-3">
          <h3><span class="pi pi-sitemap"></span>{{ parentProstorijaName }}</h3>
          <ng-container *ngIf="parentProstorijaArea">
            <p><strong>Površina:</strong> {{ parentProstorijaArea }}</p>
          </ng-container>
        </li>
      </ng-container>

      <ng-container *ngIf="parentSpremisnaJedinicaName">
        <p-divider layout="vertical"></p-divider>
        <li class="p-3">
          <h3>
            <span class="pi pi-box"></span>{{ parentSpremisnaJedinicaName }}
          </h3>
        </li>
      </ng-container>
      <ng-container *ngIf="lokacijaName">
        <p-divider layout="vertical"></p-divider>
        <li class="p-3">
          <h3>
            <span class="pi pi-map-marker"></span>{{ lokacijaName }}
          </h3>
        </li>
      </ng-container>
    </ul>
  </ng-container>
</section>
